import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Navigate, useLocation } from "react-router-dom";
import {
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Box,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  FormHelperText,
  CircularProgress,
  useTheme,
  FormControlLabel,
  Switch,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { PhotoCamera, Save, ArrowBack, Delete } from "@mui/icons-material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import CustomTextField from "../components/RTLTextField";
import {
  addNewUserFormData,
  EditUserFormData,
  getOneUser,
} from "../redux/slices/user/thunk";
import { useDispatch, useSelector } from "react-redux";
import imageCompression from "browser-image-compression";

const UserForm = () => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const { id } = useParams();
  const isEdit = id ? true : false;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));
  const location = useLocation();
  let admin = false
  if(location?.state?.admin) admin = true
  console.log("admin",admin);

  const { oneUser, loading: userLoading } = useSelector(
    (state) => state.usersSlice
  );
  const [loading, setLoading] = useState(false);
  const [photoFile, setPhotoFile] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  // Base initial values
  const baseInitialValues = {
    type: admin ? 'admin' :"family",
    userName: "",
    email: "",
    password: "",
    phoneNumber: "",
    address: "",
    location: "",
    image: "",
    description: "",
    activityDescription: "",
    bankAccountNumber: "",
    status: true,
  };

  // Validation schemas
  const validationSchemas = {
    admin: {
      create: Yup.object().shape({
        userName: Yup.string().required(t("userForm.validation.nameRequired")),
        email: Yup.string()
          .email(t("userForm.validation.emailInvalid"))
          .required(t("userForm.validation.emailRequired")),
        password: Yup.string()
          .min(6, t("userForm.validation.passwordMin"))
          .required(t("userForm.validation.passwordRequired")),
        phoneNumber: Yup.string().required(
          t("userForm.validation.phoneRequired")
        ),
        address: Yup.string().required(
          t("userForm.validation.addressRequired")
        ),
        location: Yup.string().optional(),
      }),
      edit: Yup.object().shape({
        userName: Yup.string().required(t("userForm.validation.nameRequired")),
        email: Yup.string()
          .email(t("userForm.validation.emailInvalid"))
          .required(t("userForm.validation.emailRequired")),
        password: Yup.string().test(
          "password-min",
          t("userForm.validation.passwordMin"),
          function (value) {
            if (!value) return true; // لو فاضي اعتبره valid
            return value.length >= 6;
          }
        ),

        phoneNumber: Yup.string().required(
          t("userForm.validation.phoneRequired")
        ),
        address: Yup.string().required(
          t("userForm.validation.addressRequired")
        ),
        location: Yup.string().optional(),
      }),
    },
    family: {
      create: Yup.object().shape({
        userName: Yup.string().required(t("userForm.validation.nameRequired")),
        phoneNumber: Yup.string().required(
          t("userForm.validation.phoneRequired")
        ),
        email: Yup.string()
          .email(t("userForm.validation.emailInvalid"))
          .required(t("userForm.validation.emailRequired")),
        password: Yup.string()
          .min(6, t("userForm.validation.passwordMin"))
          .required(t("userForm.validation.passwordRequired")),
        address: Yup.string().required(
          t("userForm.validation.addressRequired")
        ),
        location: Yup.string().url(
          t("userForm.validation.locationLinkInvalid")
        ),
        // .required(t("userForm.validation.locationLinkRequired")),
        description: Yup.string().optional(),
        activityDescription: Yup.string().optional(),
        bankAccountNumber: Yup.string().optional(),
      }),
      edit: Yup.object().shape({
        userName: Yup.string().required(t("userForm.validation.nameRequired")),
        email: Yup.string()
          .email(t("userForm.validation.emailInvalid"))
          .required(t("userForm.validation.emailRequired")),
       password: Yup.string().test(
  "password-min",
  t("userForm.validation.passwordMin"),
  function (value) {
    if (!value) return true; // لو فاضي اعتبره valid
    return value.length >= 6;
  }
),

        phoneNumber: Yup.string().required(
          t("userForm.validation.phoneRequired")
        ),
        address: Yup.string().required(
          t("userForm.validation.addressRequired")
        ),
        location: Yup.string().url(
          t("userForm.validation.locationLinkInvalid")
        ),
        // .required(t("userForm.validation.locationLinkRequired")),
        description: Yup.string().optional(),
        activityDescription: Yup.string().optional(),
        bankAccountNumber: Yup.string().optional(),
      }),
    },
    client: {
      create: Yup.object().shape({
        userName: Yup.string().required(t("userForm.validation.nameRequired")),
        email: Yup.string()
          .email(t("userForm.validation.emailInvalid"))
          .required(t("userForm.validation.emailRequired")),
        password: Yup.string().test(
          "password-min",
          t("userForm.validation.passwordMin"),
          function (value) {
            if (!value) return true; // لو فاضي اعتبره valid
            return value.length >= 6;
          }
        ),
        phoneNumber: Yup.string().required(
          t("userForm.validation.phoneRequired")
        ),
        address: Yup.string().required(
          t("userForm.validation.addressRequired")
        ),
        location: Yup.string().url(
          t("userForm.validation.locationLinkInvalid")
        ),
        // .required(t("userForm.validation.locationLinkRequired")),
      }),
      edit: Yup.object().shape({
        userName: Yup.string().required(t("userForm.validation.nameRequired")),
        email: Yup.string()
          .email(t("userForm.validation.emailInvalid"))
          .required(t("userForm.validation.emailRequired")),
        password: Yup.string().when([], {
          is: () => isEdit,
          then: (schema) => schema.min(6, t("userForm.validation.passwordMin")),
          otherwise: (schema) =>
            schema
              .required(t("userForm.validation.passwordRequired"))
              .min(6, t("userForm.validation.passwordMin")),
        }),
        phoneNumber: Yup.string().required(
          t("userForm.validation.phoneRequired")
        ),
        address: Yup.string().required(
          t("userForm.validation.addressRequired")
        ),
        location: Yup.string().url(
          t("userForm.validation.locationLinkInvalid")
        ),
        // .required(t("userForm.validation.locationLinkRequired")),
      }),
    },
  };

  // Form validation function
  const validate = (values) => {
    const type = values.type;
    const group = validationSchemas[type];
    if (!group) return {};

    const schema = isEdit ? group.edit : group.create;
    if (!schema) return {};

    try {
      schema.validateSync(values, { abortEarly: false });
      return {};
    } catch (validationError) {
      const errors = {};
      if (validationError.inner) {
        validationError.inner.forEach((err) => {
          if (!errors[err.path]) {
            errors[err.path] = err.message;
          }
        });
      }
      return errors;
    }
  };

  // Formik initialization
  const formik = useFormik({
    initialValues: baseInitialValues,
    validate,
    onSubmit: (values) => handleSubmit(values),
    enableReinitialize: true,
  });

  // Fetch user data when in edit mode
  useEffect(() => {
    if (isEdit && id) {
      dispatch(getOneUser({ id }));
    }
  }, [isEdit, id, dispatch]);

  // Update form when user data is fetched
  useEffect(() => {
    if (isEdit && oneUser) {
      formik.setValues({
        type: oneUser.type,
        userName: oneUser.userName || "",
        email: oneUser.email || "",
        password: "",
        phoneNumber: oneUser.phoneNumber || "",
        address: oneUser.address || "",
        location: oneUser.location || "",
        image: oneUser.image || "",
        description: oneUser.description || "",
        activityDescription: oneUser.activityDescription || "",
        bankAccountNumber: oneUser.bankAccountNumber || "",
        status: oneUser.status || true,
      });
    }
  }, [oneUser, isEdit]);

  // Handle type change
  const handleTypeChange = (e) => {
    const newType = e.target.value;
    formik.setValues({ ...baseInitialValues, type: newType });
    formik.setErrors({});
    formik.setTouched({});
    setShowPassword(false);
  };

  // Handle photo change
  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhotoFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        formik.setFieldValue("image", reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemovePhoto = () => {
    setPhotoFile(null);
    formik.setFieldValue("image", "");
  };

  // Form submission handler
  const handleSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();

    // Append all fields
    Object.entries(values).forEach(([key, value]) => {
      if (key === "password") {
        // Only send password if it's provided in edit mode
        if (isEdit && value && value.trim() !== "") {
          formData.append(key, value);
        } else if (!isEdit) {
          formData.append(key, value);
        }
      } else if (key === "image" && photoFile) {
        formData.append("image", photoFile);
      } else if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    // Add country code for phone numbers
    if (values.phoneNumber) {
      formData.append("countryCode", "+966");
    }

    try {
      let res;
      if (isEdit) {
        res = await dispatch(EditUserFormData({ id, formData })).unwrap();
      } else {
        res = await dispatch(addNewUserFormData(formData)).unwrap();
      }
      navigate(-1); // Go back after successful submission
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      setLoading(false);
    }
  };

  // Get translated title
  const getTitle = () => {
    const typeTranslated = t(`userForm.userType.${formik.values.type}`);
    const key = isEdit ? "userForm.title.edit" : "userForm.title.addNew";
    return t(key, { type: typeTranslated });
  };

  if (user?.type !== "admin") {
    return <Navigate to="/" replace />;
  }
  if (userLoading && isEdit) {
    return (
      <Container
        maxWidth="md"
        sx={{ py: 4, display: "flex", justifyContent: "center" }}
      >
        <CircularProgress size={60} />
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate(-1)}
        sx={{
          mb: 2,
          "& .MuiButton-startIcon": {
            mx: 2,
          },
        }}
      >
        {t("userForm.buttons.back")}
      </Button>

      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Box mb={3}>
          <Typography variant="h4" component="h1" gutterBottom>
            {getTitle()}
          </Typography>

          {/* User type selection (only for new users) */}
          {!isEdit && (
            <CustomTextField
              select
              fullWidth
              id="type"
              name="type"
              label={t("userForm.fields.userTypeLabel")}
              value={formik.values.type}
              isRtl={isArabic}
              onChange={(e) => {
                handleTypeChange(e);
                formik.handleChange(e);
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.type && Boolean(formik.errors.type)}
              helperText={formik.touched.type && formik.errors.type}
              sx={{ mb: 3 }}
            >
              <MenuItem value="admin">{t("userForm.userType.admin")}</MenuItem>
              <MenuItem value="family">
                {t("userForm.userType.family")}
              </MenuItem>
              {/* <MenuItem value="client">{t("userForm.userType.client")}</MenuItem> */}
            </CustomTextField>
          )}

          {/* Display user type for edit mode */}
          {isEdit && (
            <Box
              sx={{
                display: "inline-block",
                px: 2,
                py: 1,
                borderRadius: 1,
                bgcolor: "primary.light",
                color: "#ffffff",
                mb: 3,
              }}
            >
              <Typography variant="body1" fontWeight="bold">
                {t(`userForm.userType.${formik.values.type}`)}
              </Typography>
            </Box>
          )}
        </Box>

        {/* Photo Upload Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mb: 4,
            border: `1px dashed ${theme.palette.divider}`,
            borderRadius: 2,
            p: 3,
            position: "relative",
          }}
        >
          <input
            accept="image/*"
            style={{ display: "none" }}
            id="photo-upload"
            type="file"
            onChange={handlePhotoChange}
          />

          {formik.values.image ? (
            <>
              <Avatar
                src={formik.values.image}
                sx={{
                  width: 120,
                  height: 120,
                  border: `3px solid ${theme.palette.primary.main}`,
                  mb: 2,
                }}
              />
              <Box sx={{ display: "flex", gap: 1 }}>
                <label htmlFor="photo-upload">
                  <Button
                    variant="outlined"
                    color="primary"
                    component="span"
                    startIcon={<PhotoCamera />}
                    sx={{ "& .MuiButton-startIcon": { ml: 1 } }}
                  >
                    {t("userForm.photo.change")}
                  </Button>
                </label>
                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<Delete />}
                  sx={{ "& .MuiButton-startIcon": { ml: 1 } }}
                  onClick={handleRemovePhoto}
                >
                  {t("userForm.photo.remove")}
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box
                sx={{
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  bgcolor: theme.palette.grey[200],
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 2,
                }}
              >
                <PhotoCamera
                  sx={{ fontSize: 40, color: theme.palette.grey[500] }}
                />
              </Box>
              <Typography variant="body1" color="textSecondary" mb={2}>
                {t("userForm.photo.optional")}
              </Typography>
              <label htmlFor="photo-upload">
                <Button
                  variant="outlined"
                  color="primary"
                  component="span"
                  startIcon={<PhotoCamera />}
                  sx={{ "& .MuiButton-startIcon": { ml: 1 } }}
                >
                  {t("userForm.photo.upload")}
                </Button>
              </label>
            </>
          )}
        </Box>

        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3}>
            {/* Common Fields */}
            <Grid item xs={12} md={6}>
              <CustomTextField
                fullWidth
                label={t("userForm.fields.fullName")}
                name="userName"
                value={formik.values.userName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.userName && Boolean(formik.errors.userName)
                }
                helperText={formik.touched.userName && formik.errors.userName}
                isRtl={isArabic}
                required
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <CustomTextField
                fullWidth
                label={t("userForm.fields.phoneNumber")}
                name="phoneNumber"
                value={formik.values.phoneNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.phoneNumber &&
                  Boolean(formik.errors.phoneNumber)
                }
                helperText={
                  formik.touched.phoneNumber && formik.errors.phoneNumber
                }
                required
                isRtl={isArabic}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">+966</InputAdornment>
                  ),
                }}
              />
            </Grid>
            {/* Email */}
            <Grid item xs={12} md={12}>
              <CustomTextField
                fullWidth
                label={t("userForm.fields.email")}
                name="email"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                required={true}
                isRtl={isArabic}
              />
            </Grid>

            {/* Password */}
            <Grid item xs={12} md={12}>
              <CustomTextField
                fullWidth
                label={t("userForm.fields.password")}
                name="password"
                type={showPassword ? "text" : "password"}
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isRtl={isArabic}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                helperText={
                  formik.touched.password && formik.errors.password
                    ? formik.errors.password
                    : isEdit
                    ? t("userForm.messages.leavePasswordBlank")
                    : ""
                }
                required={!isEdit}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword((prev) => !prev)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* address */}
            <Grid item xs={12}>
              <CustomTextField
                fullWidth
                label={t("userForm.fields.address")}
                name="address"
                value={formik.values.address}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.address && Boolean(formik.errors.address)}
                helperText={formik.touched.address && formik.errors.address}
                isRtl={isArabic}
                required
                multiline
                rows={1}
              />
            </Grid>

            {/* Location Link */}
            <Grid item xs={12}>
              <CustomTextField
                fullWidth
                label={t("userForm.fields.locationLink")}
                name="location"
                value={formik.values.location}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isRtl={isArabic}
                error={
                  formik.touched.location && Boolean(formik.errors.location)
                }
                helperText={formik.touched.location && formik.errors.location}
                // required={formik.values.type === "family" || formik.values.type === "client"}
              />
            </Grid>

            {/* Family Specific Fields */}
            {formik.values.type === "family" && (
              <>
                {false && (
                  <Grid item xs={12}>
                    <CustomTextField
                      fullWidth
                      label={t("userForm.fields.description")}
                      name="description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      helperText={t("userForm.photo.optional")}
                      multiline
                      isRtl={isArabic}
                      rows={3}
                    />
                  </Grid>
                )}
                {false && (
                  <Grid item xs={12}>
                    <CustomTextField
                      fullWidth
                      label={t("userForm.fields.activityDescription")}
                      name="description"
                      value={formik.values.activityDescription}
                      onChange={formik.handleChange}
                      helperText={t("userForm.photo.optional")}
                      multiline
                      isRtl={isArabic}
                      rows={3}
                    />
                  </Grid>
                )}

                <Grid item xs={12} md={12}>
                  <CustomTextField
                    fullWidth
                    label={t("userForm.fields.bankAccount")}
                    name="bankAccountNumber"
                    value={formik.values.bankAccountNumber}
                    onChange={formik.handleChange}
                    helperText={t("userForm.photo.optional")}
                    isRtl={isArabic}
                  />
                </Grid>
              </>
            )}

            {/* Status Toggle */}
            {false && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      name="status"
                      checked={formik.values.status}
                      onChange={formik.handleChange}
                      color="primary"
                    />
                  }
                  label={
                    formik.values.status
                      ? t("userForm.labels.activeUser")
                      : t("userForm.labels.inactiveUser")
                  }
                />
              </Grid>
            )}

            {/* Submit Button */}
            <Grid item xs={12}>
              <Box display="flex" justifyContent="flex-end">
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  startIcon={
                    loading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <Save sx={{ ml: 1 }} />
                    )
                  }
                  disabled={loading}
                  sx={{ px: 4, py: 1.5 }}
                >
                  {isEdit
                    ? t("userForm.buttons.updateUser")
                    : t("userForm.buttons.createUser")}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
};

export default UserForm;
